/* eslint-disable no-param-reassign */
import axios from "axios";

import { failAlert, successAlert } from "./helper";

const {
  CAMPAIGN_REQUEST,
  CAMPAIGN_LIST_SUCCESS,
  CAMPAIGN_ADD_SUCCESS,
  CAMPAIGN_DELETE_SUCCESS,
  SELECTED_CAMPAIGN,
  EMPTY_CAMPAIGN,
  CAMPAIGN_FAIL,
  REMOVE_CAMPAIGN_AFTER_LOGOUT,
  SAVE_CAMPAIGN_FILTER,
  SELECTED_CONTACTS_FOR_CAMPAIGN,
  CAMPAIGN_GET_ONE_SUCCESS,
} = require("./constants");

// Get one campaign
export const getOneCampaigns = (token, campId) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({ type: CAMPAIGN_REQUEST });
      const { data, status } = await axios.get(`/api/v1/campaigns/${campId}`, {
        headers: {
          Authorization: token,
        },
      });
      if (status === 200) {
        dispatch(setSelectedCampaign(data.data.campaign)); // this line for edit campaign (when we click th edit icon) to set the selected campaign and edit it || to display the data in edit campaign field
      }
      // dispatch(getCampaigns('63107521dd42e3ac580d1250', token, 1))
      resolve(data);
    } catch (error) {
      dispatch({ type: CAMPAIGN_FAIL, payload: { type: "getCampaigns", message: error.message } });
      reject(error);
    }
  });
};

// Get campaigns
export const getCampaigns = (user_id, token, page, campType) => async (dispatch) => {
  try {
    // if (campType) { // this condition for it the the campType undefined when we fix rerender the prevCampaigns when edit camp
    dispatch({ type: CAMPAIGN_REQUEST });
    const { data, status } = await axios.get(
      `/api/v1/campaigns?skip=${page}&campType=${campType}`,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    if (status === 200) {
      dispatch({
        type: CAMPAIGN_LIST_SUCCESS,
        payload: data.data.campaigns,
        campaignsCount: data.data.campaignsCount,
        campType,
      });
    }
    // }
  } catch (error) {
    dispatch({ type: CAMPAIGN_FAIL, payload: { type: "getCampaigns", message: error.message } });
  }
};

// Edit campaign
export const editCampaign = (item_id, campaignData, token) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({ type: CAMPAIGN_REQUEST });

      const response = await axios.put(
        `/api/v1/campaigns/${item_id}`,
        {
          ...campaignData,
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      const {
        status,
        data, // changed this line to match addCampaign
      } = response;
      // if (data?.status == "warning") {
      //   dispatch({ type: "RESET_RELODD" });
      //   return;
      // }

      if (data) {
        const {
          data: { _id, task_id, messageItem, bitly_links, message }, // added this line to extract data
        } = data;

        // dispatch({
        //   type: CAMPAIGN_EDIT_SUCCESS,
        //   payload: {
        //     ...campaignData,
        //     _id: item_id,
        //     data,
        //     bitly_links,
        //     messageItem,
        //     message,
        //     canEditAndDelete: campaignData.draft || campaignData.sendNow === false,
        //     replies: []
        //   },
        //   success: true
        // });
        // dispatch(getCampaigns(userId, token, 1, "all"));

        successAlert("updated");
        resolve(data); // resolve with the data from the successful axios call
      } else {
        throw new Error("000 Failed to edit campaign");
      }
    } catch (error) {
      failAlert("updated");
      dispatch({ type: CAMPAIGN_FAIL, payload: { type: "editCampaign", message: error.message } });
      reject(error); // reject with the error
    }
  });
};

// Add campaign
export const addCampaign = (campaignData, token, userId) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const campaignDataCopy = { ...campaignData };
      dispatch({ type: CAMPAIGN_REQUEST });
      const response = await axios.post(
        "/api/v1/campaigns",
        {
          ...campaignData,
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      const { status, data } = response;
      // Logging the response data after receiving the API response
      if (status === 201) {
        const {
          data: { _id, task_id, messageItem, bitly_links, message },
        } = data;
        dispatch(getCampaigns(userId, token, 1, "all"));
        dispatch({
          type: CAMPAIGN_ADD_SUCCESS,
          payload: {
            ...campaignDataCopy,
            bitly_links,
            messageItem,
            message,
            replies: [],
            _id,
            task_id,
            canEditAndDelete: campaignDataCopy.draft || campaignDataCopy.sendNow === false,
          },
        });
        data.data.campaigns.length > 1
          ? successAlert("createMulti", data.data.campaigns.length)
          : successAlert("created");
      }
      resolve(data); // resolve with the data from the successful axios call
    } catch (error) {
      // Logging the error message if an error occurs
      console.error("Error:", error.message);

      failAlert("created");
      dispatch({ type: CAMPAIGN_FAIL, payload: { type: "addCampaign", message: error.message } });
      reject(error); // reject with the error
    }
  });
};

// Delete campaign
export const delCampaign = (campaignData, token) => async (dispatch) => {
  try {
    dispatch({ type: CAMPAIGN_REQUEST });
    const { status } = await axios.delete(`/api/v1/campaigns/${campaignData._id}`, {
      headers: {
        Authorization: token,
      },
    });
    if (status === 200) {
      dispatch({ type: CAMPAIGN_DELETE_SUCCESS, payload: campaignData });
      successAlert("deleted");
    }
  } catch (error) {
    failAlert("deleted");
    dispatch({ type: CAMPAIGN_FAIL, payload: { type: "delCampaign", message: error.message } });
  }
};

// Remove campaign after logout
export const removeCampaignAfterLogout = () => ({
  type: REMOVE_CAMPAIGN_AFTER_LOGOUT,
});

// Save campaign filter
export const saveCampaignFilter = (filter) => ({
  type: SAVE_CAMPAIGN_FILTER,
  filter,
});

// Save selected contacts for specific campaign
export const selectedContactsForCampaign = (contacts) => ({
  type: SELECTED_CONTACTS_FOR_CAMPAIGN,
  contacts,
});

// Set selected campaign
export const setSelectedCampaign = (selectedCampaign) => ({
  type: SELECTED_CAMPAIGN,
  selectedCampaign,
});

// Empty campaigns  array and selected campaign
export const emptyCampaigns = () => ({
  type: EMPTY_CAMPAIGN,
});

// Get campaigns based search
export const getCampaignsSearch = (user_id, token, page, campType, search) => async (dispatch) => {
  try {
    dispatch({ type: CAMPAIGN_REQUEST });
    const { data, status } = await axios.get(
      `/api/v1/campaigns/search?skip=${page}&campType=${campType}&searchString=${search}`,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    if (status === 200) {
      dispatch({
        type: CAMPAIGN_LIST_SUCCESS,
        payload: data.data.campaigns,
        campaignsCount: data.data.campaignsCount,
        campType,
        search,
      });
    }
  } catch (error) {
    dispatch({ type: CAMPAIGN_FAIL, payload: { type: "getCampaigns", message: error.message } });
  }
};
